import { render, staticRenderFns } from "./CommandPickerPopover.vue?vue&type=template&id=6536db71&scoped=true"
import script from "./CommandPickerPopover.vue?vue&type=script&lang=js"
export * from "./CommandPickerPopover.vue?vue&type=script&lang=js"
import style0 from "./CommandPickerPopover.vue?vue&type=style&index=0&id=6536db71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6536db71",
  null
  
)

export default component.exports